import type { FaireProductEntity } from "../../entity_types/product";

export const p_rk9fqqvnyb: FaireProductEntity = {
  token: "p_rk9fqqvnyb",
  type: "product",
  name: "Borough Stainless Salad Servers s/2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/e1ce7125547785e3c8389687b76076387fa52f814fbe340042ab50d541445b14.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57979caa5ff541d70b534cf58c8dff059d7660157b85cb00521006bf995fbe99.jpeg",
    "https://cdn.faire.com/fastly/bf85f575f37d4ed212aa8c26222492717c916785f9f12d7dfac2d6b21cabb649.jpeg",
    "https://cdn.faire.com/fastly/6475a3fbd38ab89fabe9d0f5afa454616fb7ee6b1d428f1784083c33dcdcbb20.jpeg",
    "https://cdn.faire.com/fastly/5413b6be0ec38445ae9f4af11dcd38acc550ef6410fc2a178369bda92ae6acaf.jpeg",
  ],
  priceDollars: 25,
  description:
    "BOROUGH salad servers have been inspired by our love of communal eating and feasting with friends and family. Generously proportioned with a reassuring weight, these functional serving pieces have been designed to add a sense of drama and occasion to any table setting.\n\nMaterial: 18/10 Brushed Stainless Steel",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:34.244Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
